module.exports = __webpack_public_path__ + "img/Custom.d8ff4a51.png";